// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hE","advertCardPhoto__image":"c-a_hF"};